var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',_vm._b({attrs:{"src":_vm.src,"title":_vm.title,"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share","width":"560","height":"315","allowfullscreen":""}},'iframe',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }